module.exports = __webpack_public_path__ + "img/lab.e318b0e5.png";